import React from "react";
import CoursesPage from "./CoursesPage";

export function Landing() {
  return <CoursesPage />;
}

export default Landing;
